import { render, staticRenderFns } from "./HistoryDropZone.vue?vue&type=template&id=5cb0f9e1&scoped=true&"
var script = {}
import style0 from "./HistoryDropZone.vue?vue&type=style&index=0&id=5cb0f9e1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb0f9e1",
  null
  
)

export default component.exports